import { CircularProgress as MUICircularProgress } from "@material-ui/core";
import React from "react";

type Variant = "inline" | "small" | "medium" | "large" | "xlarge";

type Props = {
  variant?: Variant;
};

const variantMap: Record<Variant, { size: number; thickness: number }> = {
  inline: { size: 12, thickness: 2 },
  small: { size: 40, thickness: 2 },
  medium: { size: 60, thickness: 3 },
  large: { size: 80, thickness: 4 },
  xlarge: { size: 100, thickness: 5 },
};

export const CircularProgress: React.FC<Props> = ({ variant = "medium" }) => {
  const { size, thickness } = variantMap[variant];
  return <MUICircularProgress size={size} thickness={thickness} />;
};
